export const MapNumberToFanMode = {
    0: 'FAN_AUTO',
    1: 'FAN_ON',
};
export const MapNumberToHumidityState = {
    0: 'HUMIDITY_OFF',
    1: 'HUMIDIFY',
    2: 'DEHUMIDIFY',
};
export var FanMode;
(function (FanMode) {
    FanMode["AUTO"] = "FAN_AUTO";
    FanMode["ON"] = "FAN_ON";
})(FanMode || (FanMode = {}));
export var FanModeLabel;
(function (FanModeLabel) {
    FanModeLabel["FAN_AUTO"] = "Auto";
    FanModeLabel["FAN_ON"] = "On";
})(FanModeLabel || (FanModeLabel = {}));
export const MapNumberToThermostatWorkingMode = {
    0: 'OFF',
    1: 'HEATING',
    2: 'COOLING',
    3: 'AUTO',
};
export var HvacSopEquipmentTypes;
(function (HvacSopEquipmentTypes) {
    HvacSopEquipmentTypes["HVAC_BOH"] = "equipmentHvacBoH";
    HvacSopEquipmentTypes["HVAC_FOH"] = "equipmentHvacFoH";
    HvacSopEquipmentTypes["HVAC_OTHRS"] = "equipmentHvacOther";
})(HvacSopEquipmentTypes || (HvacSopEquipmentTypes = {}));
export var ThermostatWorkingMode;
(function (ThermostatWorkingMode) {
    ThermostatWorkingMode["AUTO"] = "AUTO";
    ThermostatWorkingMode["HEATING"] = "HEATING";
    ThermostatWorkingMode["COOLING"] = "COOLING";
    // This option should not select-able from the main controls config, but is
    // still a valid mode (i.e. outside of timetable - set to off)
    ThermostatWorkingMode["OFF"] = "OFF";
})(ThermostatWorkingMode || (ThermostatWorkingMode = {}));
export var ThermostatWorkingModeLabel;
(function (ThermostatWorkingModeLabel) {
    ThermostatWorkingModeLabel["AUTO"] = "Auto";
    ThermostatWorkingModeLabel["HEATING"] = "Heating";
    ThermostatWorkingModeLabel["COOLING"] = "Cooling";
    ThermostatWorkingModeLabel["OFF"] = "Off";
})(ThermostatWorkingModeLabel || (ThermostatWorkingModeLabel = {}));
export var ScreenStatus;
(function (ScreenStatus) {
    ScreenStatus["UNKNOWN"] = "UNKNOWN";
    ScreenStatus["UNLOCKED"] = "UNLOCKED";
    ScreenStatus["LOCKED"] = "LOCKED";
})(ScreenStatus || (ScreenStatus = {}));
export var HvacControlLabel;
(function (HvacControlLabel) {
    HvacControlLabel["THERMOSTAT"] = "Thermostat";
    HvacControlLabel["THERMOSTAT_UNIT"] = "Thermostat Unit";
    HvacControlLabel["REMOTE_SENSORS"] = "Remote Sensors";
    HvacControlLabel["MIN_TEMP"] = "Heat To";
    HvacControlLabel["MAX_TEMP"] = "Cool To";
    HvacControlLabel["OUTSIDE_MIN_TEMP"] = "Heat To (Outside of Timetable)";
    HvacControlLabel["OUTSIDE_MAX_TEMP"] = "Cool To (Outside of Timetable)";
    HvacControlLabel["SET_POINT_RANGE"] = "Set Point";
    HvacControlLabel["THERMOSTAT_MODE"] = "Thermostat Mode";
    HvacControlLabel["THERMOSTAT_DISPLAY"] = "Thermostat Display";
    HvacControlLabel["TIME_TABLE"] = "Timetable";
    HvacControlLabel["BIAS"] = "Offset";
    HvacControlLabel["BIAS_START"] = "Start Offset";
    HvacControlLabel["BIAS_END"] = "End Offset";
    HvacControlLabel["OUTSIDE_OF_TIME_TABLE"] = "Outside of Timetable";
    HvacControlLabel["OUTSIDE_SET_POINT_RANGE"] = "Outside Set Point";
    HvacControlLabel["FAN_MODE"] = "Fan Mode";
    HvacControlLabel["ONLINE_STATUS"] = "Status";
    HvacControlLabel["THERMOSTAT_TEMPERATURE"] = "Thermostat Temperature";
    HvacControlLabel["BATTERY_LEVEL"] = "Battery Level";
    HvacControlLabel["DETECTED_SENSORS"] = "Detected Sensors";
    HvacControlLabel["NUMBER_OF_SENSORS"] = "Number of Sensors";
    HvacControlLabel["HEATING_STAGE_1"] = "Heating Stage 1 (W1)";
    HvacControlLabel["HEATING_STAGE_2"] = "Heating Stage 2 (W2)";
    HvacControlLabel["COOLING_STAGE_1"] = "Cooling Stage 1 (Y1)";
    HvacControlLabel["COOLING_STAGE_2"] = "Cooling Stage 2 (Y2)";
    HvacControlLabel["FAN_OUTPUT"] = "Fan Output (G)";
    HvacControlLabel["ADVANCED_SETTINGS"] = "Advanced Settings";
    HvacControlLabel["LOCAL_ADJUSTMENT"] = "Local Adjustment";
    HvacControlLabel["SETPOINT_LIMITS"] = "Setpoint Limits";
    HvacControlLabel["REVERT_ADJUSTMENT"] = "Revert Adjustment";
    HvacControlLabel["ENABLE_EDM"] = "Enable EDM";
    HvacControlLabel["EDM_OVERRIDE"] = "EDM Override";
})(HvacControlLabel || (HvacControlLabel = {}));
export var ThermoStatLocalSetPointDelta;
(function (ThermoStatLocalSetPointDelta) {
    ThermoStatLocalSetPointDelta[ThermoStatLocalSetPointDelta["TWO"] = 2] = "TWO";
    ThermoStatLocalSetPointDelta[ThermoStatLocalSetPointDelta["ONE"] = 1] = "ONE";
})(ThermoStatLocalSetPointDelta || (ThermoStatLocalSetPointDelta = {}));
export const mapHvacControlFieldToLabel = {
    thermostatId: HvacControlLabel.THERMOSTAT_UNIT,
    minTemp: HvacControlLabel.SET_POINT_RANGE,
    maxTemp: HvacControlLabel.SET_POINT_RANGE,
    thermostatWorkingMode: HvacControlLabel.THERMOSTAT_MODE,
    thermostatDisplayUnits: HvacControlLabel.THERMOSTAT_DISPLAY,
    timetableId: HvacControlLabel.TIME_TABLE,
    beginDelta: HvacControlLabel.BIAS,
    endDelta: HvacControlLabel.BIAS,
    outsideMinTemp: HvacControlLabel.OUTSIDE_SET_POINT_RANGE,
    outsideMaxTemp: HvacControlLabel.OUTSIDE_SET_POINT_RANGE,
    fanMode: HvacControlLabel.FAN_MODE,
};
